import axios from 'axios';
import { getHeaders } from '../lib/requests';

export async function fetchItemsFromDefaultOrder(customerId, defaultOrderNumber = 1) {
    const customer = await fetchCustomer(customerId);
    defaultOrderNumber = Math.min(Math.max(defaultOrderNumber, 1), 4);
    const defaultOrder = customer[`default_order_${defaultOrderNumber}_id`];
    if (!defaultOrder) {
        return [];
    }
    const order = await fetchOrder(defaultOrder);
    const orderItems = order.items;
    const cleanedItems = orderItems.map(item => ({
        item_id: item.item_id,
        quantity: item.quantity,
        sort_order: item.sort_order,
    }));

    // Remove any items with a quantity of 0
    return cleanedItems.filter(item => Number(item.quantity) > 0);
}

export async function fetchOrder(orderId) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiToken = localStorage.getItem('accessToken');
    try {
        const response = await axios.get(`${apiUrl}/orders/${orderId}`, {
            headers: getHeaders(apiToken),
        });

        const orderData = response.data.data[0]; // Assuming the API wraps the order data in an array
        return orderData;
    } catch (error) {
        console.error("Error fetching order details:", error);
        throw error; // Rethrow the error to be handled by the caller
    }
}

export async function fetchCustomer(customerId) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiToken = localStorage.getItem('accessToken');
    try {
        const response = await axios.get(`${apiUrl}/customers/${customerId}`, {
            headers: getHeaders(apiToken),
        });

        return response.data.data;
    } catch (error) {
        console.error("Error fetching customer:", error);
        throw error;
    }
}

export async function fetchMostRecentScheduledOrder() {
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiToken = localStorage.getItem('accessToken');
    try {
        const response = await axios.get(`${apiUrl}/orders`, {
            headers: getHeaders(apiToken),
            params: {
                limit: 1,
                delivery_status: 'scheduled'
            }
        });

        if (response.data.data.length > 0) {
            return response.data.data[0];
        } else {
            return null;
        }
    } catch (error) {
        console.error("Error fetching most recent scheduled order:", error);
        throw error;
    }
}